var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientMessageCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7155 58.338L53.51 58.1326H53.2195H30.7758C29.9697 58.1326 29.1967 57.8124 28.6267 57.2424C28.0567 56.6725 27.7365 55.8994 27.7365 55.0934V25.1684C27.7365 24.3623 28.0567 23.5893 28.6267 23.0193C29.1967 22.4493 29.9697 22.1291 30.7758 22.1291H68.182C68.9881 22.1291 69.7611 22.4493 70.3311 23.0193C70.9011 23.5893 71.2213 24.3623 71.2213 25.1684V55.0934C71.2213 55.8994 70.9011 56.6725 70.3311 57.2424C69.7611 57.8124 68.9881 58.1326 68.182 58.1326H64.4414H63.74V58.834V68.3626L53.7155 58.338Z",
    fill: "#E3EDC3",
    stroke: "#274642",
    strokeWidth: 1.40273
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7773 50.6512H30.4868L30.2814 50.8566L20.2568 60.8812V51.3525V50.6512H19.5555H15.8148C15.0088 50.6512 14.2357 50.331 13.6658 49.761C13.0958 49.191 12.7756 48.418 12.7756 47.6119V17.6869C12.7756 16.8809 13.0958 16.1078 13.6658 15.5378C14.2357 14.9679 15.0088 14.6477 15.8148 14.6477H53.2211C54.0272 14.6477 54.8002 14.9679 55.3702 15.5378C55.9401 16.1078 56.2604 16.8809 56.2604 17.6869V47.6119C56.2604 48.418 55.9401 49.191 55.3702 49.761C54.8002 50.331 54.0272 50.6512 53.2211 50.6512H30.7773Z",
    fill: "white",
    stroke: "#274642",
    strokeWidth: 1.40273
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2953 36.3904C25.3612 36.3904 27.0359 34.7157 27.0359 32.6498C27.0359 30.5839 25.3612 28.9092 23.2953 28.9092C21.2294 28.9092 19.5547 30.5839 19.5547 32.6498C19.5547 34.7157 21.2294 36.3904 23.2953 36.3904Z",
    fill: "#274642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.518 36.3904C36.5839 36.3904 38.2586 34.7157 38.2586 32.6498C38.2586 30.5839 36.5839 28.9092 34.518 28.9092C32.4521 28.9092 30.7773 30.5839 30.7773 32.6498C30.7773 34.7157 32.4521 36.3904 34.518 36.3904Z",
    fill: "#274642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7406 36.3904C47.8065 36.3904 49.4812 34.7157 49.4812 32.6498C49.4812 30.5839 47.8065 28.9092 45.7406 28.9092C43.6747 28.9092 42 30.5839 42 32.6498C42 34.7157 43.6747 36.3904 45.7406 36.3904Z",
    fill: "#274642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientMessageCenter);
export default __webpack_public_path__ + "static/media/patient_message_center.d5493319421ebe15a90f632403d45d38.svg";
export { ForwardRef as ReactComponent };